<script setup>
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import AnimatedSection from "@/components/AnimatedSection.vue";

const faqs = [
  {
    question: "¿Qué es Fenix Guardian Monitor?",
    answer:
      "Fenix Guardian Monitor es una plataforma avanzada de ciberseguridad que proporciona monitoreo en tiempo real, detección de amenazas impulsada por IA y protección integral para la infraestructura digital de tu empresa.",
  },
  {
    question: "¿Cómo funciona el monitoreo en tiempo real?",
    answer:
      "Nuestro sistema analiza continuamente el tráfico de red, logs de sistema y comportamiento de usuarios para detectar anomalías y amenazas potenciales antes de que causen daño. Recibirás alertas instantáneas cuando se detecte actividad sospechosa.",
  },
  {
    question: "¿Cuánto tiempo toma implementar la solución?",
    answer:
      "La implementación típica toma entre 24 y 72 horas dependiendo del tamaño de tu infraestructura. Nuestro equipo de expertos te guiará durante todo el proceso de configuración e integración.",
  },
  {
    question: "¿Es compatible con mi infraestructura actual?",
    answer:
      "Sí, Fenix Guardian Monitor se integra con la mayoría de sistemas operativos, servicios en la nube (AWS, Azure, GCP) y herramientas de seguridad existentes. Ofrecemos APIs y conectores para una integración sin fricciones.",
  },
  {
    question: "¿Qué incluye la prueba gratuita?",
    answer:
      "La prueba gratuita de 14 días incluye acceso completo a todas las funcionalidades del plan Profesional, soporte técnico prioritario y una sesión de onboarding personalizada con nuestro equipo.",
  },
  {
    question: "¿Cómo se manejan mis datos?",
    answer:
      "Tus datos están protegidos con encriptación AES-256 en reposo y TLS 1.3 en tránsito. Cumplimos con GDPR, ISO 27001 y SOC 2 Type II. Nunca compartimos tu información con terceros.",
  },
  {
    question: "¿Ofrecen soporte técnico?",
    answer:
      "Sí, todos los planes incluyen soporte técnico. El plan Starter incluye soporte por email, Profesional añade soporte prioritario 24/7, y Enterprise incluye un gerente de cuenta dedicado.",
  },
  {
    question: "¿Puedo cancelar en cualquier momento?",
    answer:
      "Absolutamente. No hay contratos a largo plazo obligatorios. Puedes cancelar tu suscripción en cualquier momento sin penalizaciones. Te ayudaremos a exportar tus datos si decides irte.",
  },
];
</script>

<template>
  <section id="faq" class="py-20 lg:py-32 bg-background">
    <div class="container mx-auto px-4 lg:px-8">
      <AnimatedSection animation="fade-up" class="text-center mb-12 lg:mb-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-foreground mb-4">
          Preguntas Frecuentes
        </h2>
        <p class="text-muted-foreground text-lg max-w-2xl mx-auto">
          Encuentra respuestas a las dudas más comunes sobre Fenix Guardian Monitor
        </p>
      </AnimatedSection>

      <AnimatedSection animation="fade-up" :delay="200" class="max-w-3xl mx-auto">
        <Accordion type="single" collapsible class="w-full">
          <AccordionItem
            v-for="(faq, index) in faqs"
            :key="index"
            :value="`item-${index}`"
            class="border-border/50"
          >
            <AccordionTrigger class="text-left text-foreground hover:text-accent hover:no-underline py-5">
              {{ faq.question }}
            </AccordionTrigger>
            <AccordionContent class="text-muted-foreground pb-5">
              {{ faq.answer }}
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </AnimatedSection>
    </div>
  </section>
</template>
